import { Suspense } from 'react';
import { Spinner } from '@taxdown/piccolo-web';

const WithSuspense = Component =>
  function render(props) {
    return (
      <Suspense fallback={<Spinner size="L" justify="center" />}>
        <Component {...props} />
      </Suspense>
    );
  };

export default WithSuspense;
